const IosStartURL = undefined

export default {
    IosStartURL
  }